import { useEffect } from "react";

const BASE = "https://www.camarcadigitaldesigns.com";

export default function SEO({ title, description, path = "/", noindex = false }) {
    useEffect(() => {
        document.title = title;
        const set = (selector, attr, value) => {
            const el = document.head.querySelector(selector);
            if (el) el.setAttribute(attr, value);
        };
        set('meta[name="description"]', "content", description);
        set('meta[property="og:title"]', "content", title);
        set('meta[property="og:description"]', "content", description);
        set('meta[property="og:url"]', "content", BASE + path);
        set('meta[name="twitter:title"]', "content", title);
        set('meta[name="twitter:description"]', "content", description);
        set('link[rel="canonical"]', "href", BASE + path);
        let robots = null;
        if (noindex) {
            robots = document.head.querySelector('meta[name="robots"]');
            if (!robots) {
                robots = document.createElement("meta");
                robots.setAttribute("name", "robots");
                document.head.appendChild(robots);
            }
            robots.setAttribute("content", "noindex, nofollow");
        }
        return () => {
            if (robots) robots.remove();
        };
    }, [title, description, path, noindex]);
    return null;
}
